module.exports = __webpack_public_path__ + "img/admin_panel_settings_opsz24B.645fcf5a.svg";